import React, { useRef } from "react";
import styles from "./ImmunizationHepBViewNew.module.css";
import { AddButton } from "@cpnw/ui";
import DashboardPassportFileEditorItem from "components/DashboardPassportFileEditorItem";

function GenericFileUpload({
  label = "Upload Documentation",
  disabled = false,
  files = [],
  newFiles = [],
  onAddFiles,
  onDeleteExisting,
  onDeleteNew,
  fileTypes = ".docx,.pdf,.txt,.pptx,.xlsx,.jpg,.jpeg,.png",
  maxNameLength = 255,
}) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files)
      .map((f) => {
        if (f.name.length >= maxNameLength) {
          alert(`File name must be shorter than ${maxNameLength} characters.`);
          return null;
        }

        f.id = Math.random();
        return f;
      })
      .filter(Boolean);

    if (selected.length > 0) {
      onAddFiles(selected);
    }
  };

  return (
    <>
      <div className={styles.uploadRow}>
        <p className={styles.paragraph}>{label}</p>
        {!disabled && (
          <AddButton label="Add File" onClick={() => fileInputRef.current.click()} />
        )}

        <input
          type="file"
          multiple
          accept={fileTypes}
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>

      <div className={styles.fileSetup}>
        {files.map((f) => (
          <DashboardPassportFileEditorItem
            key={f.id || f.Id}
            name={f.name || f.Name}
            onView={() => window.open(f.url || f.Url, "_blank")}
            onDelete={() => onDeleteExisting?.(f)}
            canDelete={!disabled}
          />
        ))}

        {newFiles.filter(f => f.name || f.Name).map((f) => (
          <DashboardPassportFileEditorItem
            key={f.id}
            name={f.name || f.Name}
            onView={() => window.open(URL.createObjectURL(f), "_blank")}
            onDelete={() => onDeleteNew?.(f)}
            canDelete={!disabled}
          />
        ))}
      </div>
    </>
  );
}

export default GenericFileUpload;
